import { useBooleanState } from '@cian/react-utils';
import * as React from 'react';

import { SpecialProjectBannerSkeleton } from '../../components/SpecialProjectBannerSkeleton';
import { AdfoxContextProviderProps } from '../../utils/AdfoxContext';
import { AdFoxBannerContainer } from '../AdFoxBannerContainer';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { AD_BANNER_MF_MANIFEST_SETTING_KEY } from 'shared/constants/microfrontends';
import { AdBannerMicrofrontendSellersContainer } from '../AdBannerMicrofrontendSellersContainer';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  isSp: true,
  place: 'above_offers',
};

const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 174 };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'domzh', p2: 'hyhj' };

export const SellersAdfoxBannerContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const manifest = config.get<IMicrofrontendManifest>(AD_BANNER_MF_MANIFEST_SETTING_KEY);
  const { state: isVisibleBanner, setFalse: setBannerInvisible } = useBooleanState(true);

  if (!isVisibleBanner) {
    return null;
  }

  return (
    <SpecialProjectBannerSkeleton dataName="SellersAdfoxBanner">
      {manifest ? (
        <AdBannerMicrofrontendSellersContainer
          manifest={manifest}
          onStub={setBannerInvisible}
          onError={setBannerInvisible}
          onClose={setBannerInvisible}
        />
      ) : (
        <AdFoxBannerContainer
          onStub={setBannerInvisible}
          onError={setBannerInvisible}
          bannerName="Баннер AdFox для вторичной недвижимости"
          size={SIZE}
          pParams={P_PARAMS}
          postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
        />
      )}
    </SpecialProjectBannerSkeleton>
  );
};
